import React from "react";
import ReactDOM from "react-dom/client";
import 'react-toastify/dist/ReactToastify.css';
import "./index.css";
import "./assets/css/custom.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "../src/assets/vendor/aos/aos.css";
import "../src/assets/vendor/glightbox/css/glightbox.min.css";
import "../src/assets/vendor/remixicon/remixicon.css";
import "../src/assets/vendor/swiper/swiper-bundle.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import SignUp from "./components/SignUp";
import SignIn from "./components/SingIn";
import ContactUs from "./components/ContactUs";
import 'bootstrap/dist/css/bootstrap.min.css';
import HowItWorks from "./components/HowItWorks";
import LogoDesigning from "./components/Partner/Digital/LogoDesigning";
import AudioVideoEditing from "./components/Partner/Digital/AudioVideoEditing";
import DigitalMarketing from "./components/Partner/Digital/DigitalMarketing";
import AudioVideoEditingBuyer from "./components/Buyer/Digital/AudioVideoEditing";
import LogoDesigningBuyer from "./components/Buyer/Digital/LogoDesigning";
import DigitalMarketingBuyer from "./components/Buyer/Digital/DigitalMarketing";
import TermsOfServices from "./components/TermsOfServices";
import LogoDesigningDetail from "./components/Partner/Digital/LogoDesigning/LogoDesigningDetail";
import OthersDigital from "./components/Partner/Digital/Others";
import OthersDigitalBuyer from "./components/Buyer/Digital/Others";
import GSTPartner from "./components/Partner/Tax/GST";
import ITRPartner from "./components/Partner/Tax/ITR";
import OthersPartnerTax from "./components/Partner/Tax/Others";
import RelationshipPartner from "./components/Partner/Astro/Relationship";
import CareerPartner from "./components/Partner/Astro/Career/Index";
import OthersAstroPartner from "./components/Partner/Astro/Others";
import RelationshipHealPartner from "./components/Partner/Heal/Relationship";
import CareerHealPartner from "./components/Partner/Heal/Career";
import OthersHealPartner from "./components/Partner/Heal/Others";
import CareerAstroBuyer from "./components/Buyer/Astro/Career/Index";
import RelationshipAstroBuyer from "./components/Buyer/Astro/Relationship";
import OthersAstroBuyer from "./components/Buyer/Astro/Others";
import GSTTaxBuyer from "./components/Buyer/Tax/GST";
import ITRTaxBuyer from "./components/Buyer/Tax/ITR";
import OthersTaxBuyer from "./components/Buyer/Tax/Others";
import CareerHealBuyer from "./components/Buyer/Heal/Career";
import RelationshipHealBuyer from "./components/Buyer/Heal/Relationship";
import OthersHealBuyer from "./components/Buyer/Heal/Others";
import PostTaskMain from "./components/PostTaskMain";
import BecomeSeller from "./components/BecomeSeller";
import SubmitSignUp from "./components/SignUp/SubmitSignUp";
import ManageProfile from "./components/ManageProfile";
import Feedback from "./components/Feedback";
import ViewNotification from "./components/ViewNotification";
import BankAccountDetails from "./components/BankAccountDetails";
import GSTDetails from "./components/GSTDetails";
import AboutUsTaskde from "./components/AboutUs";
import ReturnAndRefund from "./components/ReturnAndRefund";
import UserDetails from "./components/SignUp/UserDetails";
import BankAccountDetailsSignUp from "./components/SignUp/BankAccountDetailsSignUp";
import AddAddressDetails from "./components/SignUp/AddAddressDetails";
import Services from "./components/Services";
import SearchList from "./components/SearchList";
import MyTaskBuyer from "./components/Buyer/MyTask";
import MyTaskSeller from "./components/Partner/MyTask";
import BrowseTasks from "./components/Partner/BrowseTasks";
import BrowseAllTasks from "./components/Partner/BrowseTasks/BrowseAllTasks";
import BrowseTasksBuyer from "./components/Buyer/BrowseTasks";
import ChatsSeller from "./components/Partner/Chats";
import ChatsBuyer from "./components/Buyer/Chats";
import ForgotPassword from "./components/ForgotPassword";
import MakeanOffer from "./components/MakeanOffer";
import MytaskListing from "./components/Buyer/MyTask/MytaskListing";
import MytaskListingBuyer from "./components/Buyer/MyTask/MytaskListing";
import MytaskHistoryBuyer from "./components/Buyer/MyTask/MytaskListing/MytaskHistory";
import MytaskAssignedBuyer from "./components/Buyer/MyTask/MytaskAssigned";
import ChatsOnline from "./components/Buyer/Chats/ChatsOnline";
import MytaskAssignHistory from "./components/Buyer/MyTask/MytaskAssigned/MytaskAssignHistory";
import MytaskCompleted from "./components/Buyer/MyTask/MytaskCompleted";
import Chat from "./components/Chat";
import MytaskListingSeller from "./components/Partner/MyTask/MytaskListing";
import MytaskCompletedSeller from "./components/Partner/MyTask/MytaskCompleted";
import MytaskHistorySeller from "./components/Partner/MyTask/MytaskListing/MytaskHistory";
import MakeanOfferListing from "./components/MakeanOffer/MakeanOfferListing";
// import ChatCall from "./components/ChatCall";
import ToasterMessage from "./components/ToasterMessage";
import App11 from "./components/ChatCall/demo2";
import RazorpayIntegration from "./components/RazorpayIntegration";
import PaymentHistoryListing from "./components/Buyer/PaymentHistory/PaymentHistoryListing";
import PaymentHistoryBuyer from "./components/Buyer/PaymentHistory";
import PaymentHistorySeller from "./components/Partner/PaymentHistory";
import ChatsUserListBuyer from "./components/Buyer/Chats/ChatUserList";
import ChatsUserListSeller from "./components/Partner/Chats/ChatUserList";
import VerifyMobile from "./components/verifyMobile";
import Waitingpage from "./components/ChatCall/waitingpage";
import Chatpage from "./components/ChatCall/Chatpage";
import { ZegoUIKitPrebuilt } from '@zegocloud/zego-uikit-prebuilt';
import ZIM from "zego-zim-web";
import ErrorPage from "./components/404 Page";
import ChatCallInvitation from "./components/ChatCall/chatCallInvitation.js";
import { Provider } from "react-redux";
import store from "./store/store";
import ComplaintForm from "./components/ComplaintForm";
import Phonepe from "./components/Phonepe/phonepe";
import PhonepeFailed from "./components/Payment/phonepefalied";
import Phonepesuccess from "./components/Payment/phonepesuccess";
import Phonepepending from "./components/Payment/phonepepending";

// import ChatCallInvitation from "./components/ChatCall/chatCallInvitation.js";

const root = ReactDOM.createRoot(document.getElementById('root'));

// let zp = null
// if (userID) {
//   const userName = userID;
//   const appID = 1485872462;
//   const serverSecret = "8e9ec2e8a91d24fd83fc68a74bda9f04";
//   const TOKEN = ZegoUIKitPrebuilt.generateKitTokenForTest(appID, serverSecret, roomID, userID, userName);
//   zp = ZegoUIKitPrebuilt.create(TOKEN);
//   zp.addPlugins({ ZIM });
// }

root.render(
  <React.Fragment>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />


          <Route path='/phonepe-success' element={<Phonepesuccess />} />
          <Route path='/phonepe-failed' element={<PhonepeFailed />} />
          <Route path='/phonepe-pending' element={<Phonepepending />} />
          {/* Chat Starts */}
          <Route path='/chat' element={<Chat zp={null} />} />


          {/* Chat Ends */}

          {/* Sign Up Starts */}
          <Route path='/signup' element={<SignUp />} />
          <Route path='/signupnext' element={<SubmitSignUp />} />
          <Route path='/userdetails' element={<UserDetails />} />
          <Route path='/bankaccountdetails' element={<BankAccountDetailsSignUp />} />
          <Route path='/addressdetails' element={<AddAddressDetails />} />
          {/* Sign Up Ends */}

          {/* Sign Up Starts */}
          <Route path='/signin' element={<SignIn />} />
          <Route path='/verifymobile' element={<VerifyMobile />} />
          <Route path='/forgotpassword' element={<ForgotPassword />} />
          {/* Sign Up Ends */}

          {/* Make an Offer Starts */}
          <Route path='/makeanofferlist' element={<MakeanOfferListing />} />
          <Route path='/makeanoffer' element={<MakeanOffer />} />
          {/*Make an Offer Ends */}

          {/* Search Listing Starts */}
          <Route path='/searchlist' element={<SearchList />} />
          {/* Search Listing Ends */}
          {/* Contact Us Starts */}
          <Route path='/contactus' element={<ContactUs />} />
          {/* Contact Us Ends */}

          {/* About Us Starts */}
          <Route path='/aboutus' element={<AboutUsTaskde />} />
          {/* About Us Ends */}


          {/* Return & Refund Starts */}
          <Route path='/return-refund-policy' element={<ReturnAndRefund />} />
          {/* Return & Refund Ends */}

          {/* Become a Seller Starts  */}
          <Route path='/becomeseller' element={<BecomeSeller />} />
          {/* Become a Seller Ends  */}


          {/* Partner Digital Category Starts */}
          <Route path='/logodesigningpartner' element={<LogoDesigning />} />
          <Route path='/audiovideoeditingpartner' element={<AudioVideoEditing />} />
          <Route path='/digitalmarketingpartner' element={<DigitalMarketing />} />
          <Route path='/othersdigital' element={<OthersDigital />} />

          <Route path='/logodesigningdetail' element={<LogoDesigningDetail />} />
          {/* Partner Digital Category Ends */}

          {/* Partner Tax Category Starts */}
          <Route path='/gstpartner' element={<GSTPartner />} />
          <Route path='/itrpartner' element={<ITRPartner />} />
          <Route path='/otherstaxpartner' element={<OthersPartnerTax />} />

          {/* Partner Tax Category Ends */}

          {/* Partner Tax Category Starts */}
          <Route path='/relationshippartner' element={<RelationshipPartner />} />
          <Route path='/careerpartner' element={<CareerPartner />} />
          <Route path='/othersastropartner' element={<OthersAstroPartner />} />

          {/* Partner Tax Category Ends */}

          {/* Partner Heal Category Starts */}
          <Route path='/relationshiphealpartner' element={<RelationshipHealPartner />} />
          <Route path='/careerhealpartner' element={<CareerHealPartner />} />
          <Route path='/othershealpartner' element={<OthersHealPartner />} />

          {/* Partner Tax Category Ends */}

          {/* Buyer Digital Category Starts */}
          <Route path='/audiovideoeditingbuyer' element={<AudioVideoEditingBuyer />} />
          <Route path='/tasks/:id' element={<LogoDesigningBuyer />} />
          <Route path='/digitalmarketingbuyer' element={<DigitalMarketingBuyer />} />
          <Route path='/othersdigitalbuyer' element={<OthersDigitalBuyer />} />
          {/* Buyer Digital Category Ends */}

          {/* Buyer Astro Category Starts */}
          <Route path='/careeratrobuyer' element={<CareerAstroBuyer />} />
          <Route path='/relationshipastrobuyer' element={<RelationshipAstroBuyer />} />
          <Route path='/othersastrobuyer' element={<OthersAstroBuyer />} />
          {/* Buyer Astro Category Ends */}

          {/* Buyer Tax Category Starts */}
          <Route path='/gstatrobuyer' element={<GSTTaxBuyer />} />
          <Route path='/itrastrobuyer' element={<ITRTaxBuyer />} />
          <Route path='/otherstaxbuyer' element={<OthersTaxBuyer />} />
          {/* Buyer Tax Category Ends */}

          {/* Buyer Heal Category Starts */}
          <Route path='/careerhealbuyer' element={<CareerHealBuyer />} />
          <Route path='/relationshiphealbuyer' element={<RelationshipHealBuyer />} />
          <Route path='/othershealbuyer' element={<OthersHealBuyer />} />
          {/* Buyer Heal Category Ends */}

          {/* How it Works Starts */}
          <Route path='/howitworks' element={<HowItWorks />} />
          {/* How it Works Ends */}

          {/* Browse Tasks Starts */}
          <Route path='/browsetasks' element={<BrowseTasks />} />
          <Route path='/browsealltasks' element={<BrowseAllTasks />} />
          <Route path='/browsetasksbuyer' element={<BrowseTasksBuyer />} />
          {/* Browse Tasks Ends */}

          {/* Post Task Starts */}
          <Route path='/services' element={<Services />} />
          <Route path='/posttask/:id' element={<PostTaskMain />} />
          {/* Post Task Ends */}

          {/* Privacy Policy Starts */}
          <Route path='/privacypolicy' element={<PrivacyPolicy />} />
          {/* Privacy Policy Ends */}

          {/* Terms Of Servcies Starts */}
          <Route path='/termsofservices' element={<TermsOfServices />} />
          {/* Terms Of Servcies Ends */}

          {/* Manage Response Starts */}
          <Route path='/manageprofile' element={<ManageProfile />} />
          {/* Manage Response Ends */}

          {/* Feedback Starts */}
          <Route path='/feedback' element={<Feedback />} />
          {/* Feedback Ends */}

          {/* Notification Starts */}
          <Route path='/viewnotification' element={<ViewNotification />} />
          {/* Notification Ends */}

          {/* My Task Starts */}
          <Route path='/mytaskbuyer' element={<MyTaskBuyer />} />
          <Route path='/mytasklistingbuyer' element={<MytaskListingBuyer />} />
          <Route path='/mytaskhistorybuyer' element={<MytaskHistoryBuyer />} />
          <Route path='/mytaskassignedbuyer' element={<MytaskAssignedBuyer />} />
          <Route path='/mytaskassignhistorybuyer' element={<MytaskAssignHistory />} />
          <Route path='/mytaskcompletedbuyer' element={<MytaskCompleted />} />
          <Route path='/mytasklistingseller' element={<MytaskListingSeller />} />
          <Route path='/mytaskhistoryseller' element={<MytaskHistorySeller />} />
          <Route path='/mytaskcompletedseller' element={<MytaskCompletedSeller />} />
          <Route path='/mytaskseller' element={<MyTaskSeller />} />
          {/* My Task Ends */}

          {/*Payment History Starts */}
          <Route path='/paymenthistorybuyer' element={<PaymentHistoryBuyer />} />
          <Route path='/paymenthistorylist/:id' element={<PaymentHistoryListing />} />
          <Route path='/paymenthistoryseller' element={<PaymentHistorySeller />} />
          {/* Payment History Ends */}

          {/*Toaster Starts */}
          <Route path='/toastmessage' element={<ToasterMessage />} />
          {/* Toaster Ends */}

          {/*Bank Account Details Starts */}
          <Route path='/bankdetails' element={<BankAccountDetails />} />
          {/* Bank Account Details Ends */}

          {/*GST Deatils Starts */}
          <Route path='/gstdetails' element={<GSTDetails />} />
          {/* GST Details Ends */}

          <Route path="/razorpay" element={<RazorpayIntegration />} />

          {/*Chats Starts */}
          <Route path='/chatsbuyer/:id' element={<ChatsBuyer />} />
          <Route path='/chatsuserlistbuyer' element={<ChatsUserListBuyer />} />
          <Route path='/chatsuserlistseller' element={<ChatsUserListSeller />} />
          <Route path='/chatsonline' element={<ChatsOnline />} />
          <Route path='/chatsseller/:id' element={<ChatsSeller />} />
          <Route path='/call' element={<ChatCallInvitation />} />
          <Route path='/waitingpage' element={<Waitingpage />} />
          <Route path='/chatpage' element={<Chatpage />} />
          {/* Chats Ends */}

          {/* Complaint Form Starts */}
          <Route path='/complaint' element={<ComplaintForm />} />
          {/*  Complaint Form Ends */}

          <Route path='/*' element={<ErrorPage />} />

          <Route path='/phonepe' element={<Phonepe />} />

        </Routes>
      </BrowserRouter>
    </Provider>
  </React.Fragment>
  ,
);